import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const currencies = {
    "es-AR": {
        decimalSeparator: ",",
        localeCode: "de-DE",
    },
    "pt-BR": {
        decimalSeparator: ",",
        localeCode: "de-DE",
    },
    "es-MX": {
        decimalSeparator: ".",
        localeCode: "es-MX",
    },
};
export function PriceView({ id, price, locale }) {
    const decimalSeparators = currencies[locale].decimalSeparator || ",";
    if (!price.includes(decimalSeparators)) {
        return _jsxs("span", Object.assign({ id: id }, { children: ["$ ", price] }), void 0);
    }
    const [entire, cents] = price.split(decimalSeparators);
    return (_jsxs("span", Object.assign({ id: id }, { children: ["$ ", entire, _jsx("sup", { children: cents }, void 0)] }), void 0));
}
//# sourceMappingURL=PriceView.js.map